module.exports = __webpack_public_path__ + "static/img/login_title.a58b8e37.png";